export default __webpack_public_path__ + "static/media/nft-mobile.713e220f.png";